<div class="container mt-4">

  <div class="row mb-3">
    <div class="col-12">
      <h1>
        Identi App End User Licence Agreement
      </h1>
      <p class="text-muted">
        Effective Date: 1st September 2026
      </p>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">

      <p>
        <strong>Please read these licence terms carefully.</strong>
      </p>
      <p>
        These terms govern your use of the App. Your purchase and use of the Smart Tag product and Service are also subject to identi Terms and Conditions, which you accepted when you subscribed.
      </p>
      <p>
        <strong>By clicking on the "Accept" button below you agree to these terms which will bind you.</strong>
      </p>

      <p>
        Click on the links below to go straight to more information on each area:
      </p>
      <ul>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(A1)">
            Who we are and what this agreement does
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(B1)">
            Your privacy
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(C1)">
            Other terms that may apply to you
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(D1)">
            Apple App Store's (and Google Play's) terms also apply
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(E1)">
            Operating system requirements
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(F1)">
            Support for the App and how to tell us about problems
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(G1)">
            How you may use the App, including how many devices you may use it on
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(H1)">
            You must be 18 to accept these terms
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(I1)">
            You may not transfer the App to someone else
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(J1)">
            Changes to these terms
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(K1)">
            Updates to the App and changes to the Service
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(L1)">
            If someone else owns the device you are using
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(M1)">
            We are not responsible for other websites or services you link to
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(N1)">
            Licence restrictions
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(O1)">
            Acceptable use restrictions
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(P1)">
            Intellectual property rights
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(Q1)">
            Our responsibility for loss or damage suffered by you
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(R1)">
            We may end your rights to use the App and the Service if you break these terms
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(S1)">
            We may transfer this agreement to someone else
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(T1)">
            You need our consent to transfer your rights to someone else
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(U1)">
            No rights for third parties
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(V1)">
            If a court finds part of this contract illegal, the rest will continue in force
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(W1)">
            Even if we delay in enforcing this contract, we can still enforce it later
          </a>
        </li>
        <li>
          <a
            class="btn btn-link p-0"
            (click)="helperService.scrollToElement(X1)">
            Which laws apply to this agreement and where you may bring legal proceedings
          </a>
        </li>
      </ul>

      <h4 #A1 id="A1" class="my-3">
        Who we are and what this agreement does
      </h4>

      <p>
        We, Identicare Limited of Moorside, Monks Cross Drive, Huntington, York, YO32 9LB (company number 12960490) trading as 'identi' ("we", "us", "our"), license you to use:
      </p>
      <ul>
        <li>the identi Smart Tag mobile application software (the "App") and any updates or supplements to it;</li>
        <li>any related in-app help documentation (the "Documentation"); and</li>
        <li>the Smart Tag reunification service you connect to via the App, including the pet profile, tag-scan notification, 'mark as lost', wellbeing calendar and related features (the "Service"),</li>
      </ul>
      <p>
        as permitted in these terms.
      </p>
      <p>
        <strong>The Service does not include the web page that a finder of a lost pet reaches by scanning the SmartTag QR code (the "Finder Page").</strong> A person viewing or using the Finder Page has not downloaded the App and is not a party to this agreement. Their use of the Finder Page is instead governed by the separate SmartTag Finder Terms of Use and SmartTag Finder Privacy Notice referred to in the table below.
      </p>

      <h4 #B1 id="B1" class="my-3">
        Your privacy
      </h4>

      <p>
        Under data protection legislation, we are required to provide you with certain information including who we are, how we process your personal data and for what purposes and your rights in relation to your personal data and how to exercise them. This information is provided in our <a [routerLink]="['/privacy']">SmartTag Privacy Notice</a>, and it is important that you read that information.
      </p>

      <h4 #C1 id="C1" class="my-3">
        Other terms that may apply to you
      </h4>

      <p>
        The following also form part of these terms:
      </p>
      <ul>
        <li>
          our <a [routerLink]="['/cookies']">Cookie Policy</a> sets out information about the cookies used by the App;
        </li>
        <li>
          our Acceptable Use Restrictions - see below. If the App is to enable to allow you to purchase any goods or services, our SmartTag Terms and Conditions will apply to each purchase.
        </li>
      </ul>

      <h5 class="my-3">
        Additional terms for specific Services
      </h5>

      <p>
        In addition, the Service set out below is governed by its own terms of use and privacy notice:
      </p>
      <ul>
        <li>
          Service: Tag Scan / Finder Page - Terms of use: <a [routerLink]="['/finder-terms-of-use']">SmartTag Finder Terms of Use</a>; Privacy notice: <a [routerLink]="['/finder-privacy-policy']">SmartTag Finder Privacy Notice</a>.
        </li>
      </ul>

      <h4 #D1 id="D1" class="my-3">
        Apple App Store's (and Google Play's) terms also apply
      </h4>

      <p>
        The ways in which you can use the App and any Documentation may also be controlled by the Apple App Store's and Google Play's rules and policies, and those rules and policies will apply instead of these terms where there is a difference between the two.
      </p>

      <h4 #E1 id="E1" class="my-3">
        Operating system requirements
      </h4>

      <p>
        This App requires an iOS device operating iOS 15.6 or later, or an Android device operating Android 10 (API 29) or later.
      </p>

      <h4 #F1 id="F1" class="my-3">
        Support for the App and how to tell us about problems
      </h4>

      <p>
        <strong>Support.</strong> If you want to learn more about the App or the Service or have any problems using them, please see our support resources at identi.pet.
      </p>
      <p>
        <strong>Contacting us (including with complaints).</strong> If you think the App or the Service is faulty or misdescribed, or wish to contact us for any other reason, please email our customer service team at hello&#64;identicare.pet or call them on 0330 9128077.
      </p>
      <p>
        <strong>How we will communicate with you.</strong> If we need to contact you we will do so by email or by in-app notification, using the contact details you have provided to us.
      </p>

      <h4 #G1 id="G1" class="my-3">
        How you may use the App, including how many devices you may use it on
      </h4>

      <p>
        In return for your agreeing to comply with these terms you may:
      </p>
      <ul>
        <li>download or stream a copy of the App onto one of your devices and view, use and display the App and the Service on that device for your personal purposes only;</li>
        <li>use any Documentation to support your permitted use of the App and the Service;</li>
        <li>provided you comply with the Licence Restrictions below, make up to one copy of the App for back-up purposes; and</li>
        <li>receive and use any free supplementary software code or update of the App incorporating patches and corrections of errors as we may provide to you.</li>
      </ul>

      <h4 #H1 id="H1" class="my-3">
        You must be 18 to accept these terms
      </h4>

      <p>
        You must be 18 or over to accept these terms and activate the Service.
      </p>

      <h4 #I1 id="I1" class="my-3">
        You may not transfer the App to someone else
      </h4>

      <p>
        We are giving you personally the right to use the App and the Service as set out above. You may not otherwise transfer the App or the Service to someone else, whether for money, for anything else or for free. If you sell any device on which the App is installed, you must remove the App from it. If your pet is transferred to a new keeper, the Service will end and they will need to subscribe and pay for the Service in their name as a new user.
      </p>

      <h4 #J1 id="J1" class="my-3">
        Changes to these terms
      </h4>

      <p>
        We may need to change these terms to reflect changes in law or best practice, or to deal with additional features which we introduce.
      </p>
      <p>
        We will give you at least 30 days' notice of any change by email or by notifying you of the change when you next open the App.
      </p>
      <p>
        If you do not accept the notified changes, you may continue to use the App and the Service in accordance with the existing terms, but certain new features may not be available to you.
      </p>

      <h4 #K1 id="K1" class="my-3">
        Updates to the App and changes to the Service
      </h4>

      <p>
        From time to time we may automatically update the App and change the Service to improve performance, enhance functionality, reflect changes to the operating system, or address security issues. Alternatively, we may ask you to update the App for these reasons.
      </p>
      <p>
        If you choose not to install such updates, or if you opt out of automatic updates, you may not be able to continue using the App and the Service, and you may not receive tag-scan or lost-pet notifications promptly.
      </p>
      <p>
        The App will always match the description of it provided to you when you started using it.
      </p>

      <h4 #L1 id="L1" class="my-3">
        If someone else owns the device you are using
      </h4>

      <p>
        If you download or stream the App onto any other device not owned by you, you must have the owner's permission to do so. You will be responsible for complying with these terms, whether or not you own the other device.
      </p>

      <h4 #M1 id="M1" class="my-3">
        We are not responsible for other websites or services you link to
      </h4>

      <p>
        The App or the Service may contain links to, or let you activate, independent third-party websites or services which are not provided by us - for example, if you choose to download an instant poster, create a social media post, or alert a wider community of keepers or vets through the Service. Such independent sites and services are not under our control, and we are not responsible for, and have not checked or approved, their content, their terms, or their privacy policies (if any). You will need to make your own judgement about whether to use them.
      </p>

      <h4 #N1 id="N1" class="my-3">
        Licence restrictions
      </h4>

      <p>
        You agree that you will:
      </p>
      <ul>
        <li>not rent, lease, sub-license, loan, provide, or otherwise make available the App or the Service in any form, in whole or in part, to any person without our prior written consent;</li>
        <li>not copy the App, any Documentation or Service, except as part of normal use or where necessary for back-up or operational security;</li>
        <li>not translate, merge, adapt, vary, alter or modify the whole or any part of the App, any Documentation or Service, nor permit them to be combined with or incorporated into any other programs, except as necessary to use the App and the Service as permitted in these terms;</li>
        <li>not disassemble, de-compile, reverse engineer or create derivative works based on the whole or any part of the App or the Service, except to the limited extent permitted by sections 50B and 296A of the Copyright, Designs and Patents Act 1988; and</li>
        <li>comply with all applicable technology control or export laws and regulations that apply to the technology used or supported by the App or the Service.</li>
      </ul>

      <h4 #O1 id="O1" class="my-3">
        Acceptable use restrictions
      </h4>

      <p>
        You must use the App and the Service only for lawful purposes. You must not, and must not attempt to:
      </p>
      <ul>
        <li>use the App or the Service in any way that breaches any applicable law or regulation, or that is unlawful or fraudulent, or has any unlawful or fraudulent purpose or effect, or act maliciously, for example by hacking into or inserting malicious code, such as viruses, or harmful data, into the App, the Service or any operating system;</li>
        <li>use the App or the Service for the purpose of harming or attempting to harm minors in any way;</li>
        <li>provide false or misleading information in your pet profile or contact details, or fail to keep such information up to date, where this could hinder the reunification of a pet;</li>
        <li>misuse the tag-scan, lost-pet, information-sharing or community-alert features of the Service - for example, by submitting a false report that a pet is lost, falsely claiming to be a pet's keeper, or using information shared by a finder for any purpose other than reunification;</li>
        <li>send, or procure the sending of, any unsolicited or unauthorised advertising or promotional material, or any other form of spam, using the App or the Service;</li>
        <li>infringe our intellectual property rights or those of any third party in relation to your use of the App or the Service;</li>
        <li>
          transmit, submit, or upload any material (including in a pet profile) that:
          <ul>
            <li>is defamatory of any person;</li>
            <li>is obscene, offensive, hateful or inflammatory, or promotes sexually explicit material or violence;</li>
            <li>promotes discrimination based on race, sex, religion, nationality, disability, sexual orientation or age;</li>
            <li>is likely to deceive any person, or is made in breach of any legal duty owed to a third party, such as a contractual duty or a duty of confidence;</li>
            <li>promotes any illegal activity;</li>
            <li>is threatening, or invades another person's privacy, or is likely to harass, upset, embarrass, alarm or annoy any other person; or</li>
            <li>is used to impersonate any person, or to misrepresent your identity or affiliation with any person, or gives the impression that it emanates from us where this is not the case;</li>
          </ul>
        </li>
        <li>reproduce, duplicate, copy or resell any part of the App or the Service (including content of the Finder Page or any pet profile) without our prior written consent, except as permitted under 'How you may use the App' above;</li>
        <li>access without authority, interfere with, damage or disrupt any part of the App or the Service, any equipment or network on which it is stored, any software used in its provision, or any equipment, network or software owned or used by any third party, or otherwise use the App or the Service in a way that could damage, disable, overburden, impair or compromise our systems or security or interfere with other users; and</li>
        <li>collect or harvest any information or data from the Service or our systems, or attempt to decipher any transmissions to or from the servers running the Service.</li>
      </ul>

      <h4 #P1 id="P1" class="my-3">
        Intellectual property rights
      </h4>

      <p>
        All intellectual property rights in the App, any Documentation and the Service throughout the world belong to us (or our licensors), and the rights in the App and the Service are licensed, not sold, to you. You have no intellectual property rights in, or to, the App, any Documentation or the Service other than the right to use them in accordance with these terms. If you upload any photograph(s) or image(s) of your pet or content for the purposes of identifying your pet as missing and/or facilitating reunification or for any other purposes connected with the Service by doing so you licence (permit) us to store, reproduce and use that photograph, image or content and (if required) to edit or modify any such photo, image or content as we may reasonably require solely for the purposes of providing the Service, including but not limited to producing lost pet posters or missing pet notifications.
      </p>

      <h4 #Q1 id="Q1" class="my-3">
        Our responsibility for loss or damage suffered by you
      </h4>

      <p>
        <strong>We are responsible to you for foreseeable loss and damage caused by us.</strong> If we fail to comply with these terms, we are responsible for loss or damage you suffer that is a foreseeable result of our breaking these terms or our failing to use reasonable care and skill, but we are not responsible for any loss or damage that is not foreseeable.
      </p>
      <p>
        <strong>We do not exclude or limit in any way our liability to you where it would be unlawful to do so.</strong> This includes liability for death or personal injury caused by our negligence or the negligence of our employees, agents or subcontractors, or for fraud or fraudulent misrepresentation.
      </p>
      <p>
        <strong>The Service does not guarantee reunification with your pet.</strong> The Service is designed to help facilitate the reunification of a lost pet with its keeper, including by enabling finders to share their location and contact details with you. We do not guarantee that a lost pet will be found, that a finder will choose to share their information, or that reunification will occur within any particular time. The Service is not an emergency service - if your pet, or a person, is in immediate danger, you should contact the emergency services directly.
      </p>
      <p>
        <strong>When we are liable for damage to your property.</strong> If defective digital content that we have supplied damages a device or digital content belonging to you, we will either repair the damage or pay you compensation.
      </p>
      <p>
        <strong>We are not liable for business losses.</strong> The App is for domestic and private use. If you use the App for any commercial, business or resale purpose, we will have no liability to you for any loss of profit, loss of business, business interruption, or loss of business opportunity.
      </p>
      <p>
        <strong>Check that the App and the Service are suitable for you.</strong> The App and the Service have not been developed to meet your individual requirements. Please check that the facilities and functions of the App and the Service (as described on the app store listing and in any Documentation) meet your requirements.
      </p>
      <p>
        <strong>We are not responsible for events outside our control.</strong> If our provision of the Service or support for the App is delayed by an event outside our control, we will contact you as soon as possible and take steps to minimise the effect of the delay. Provided we do this, we will not be liable for delays caused by the event.
      </p>
      <p>
        Some features of the App depend on your device, operating system, internet connection, location services, notification settings or third-party services. We cannot guarantee that these features will always be available or that notifications will always be delivered immediately.
      </p>

      <h4 #R1 id="R1" class="my-3">
        We may end your rights to use the App and the Service if you break these terms
      </h4>

      <p>
        We may end your rights to use the App and the Service at any time by contacting you if you have broken these terms in a serious way. If what you have done can be put right, we will give you a reasonable opportunity to do so.
      </p>
      <p>
        If we end your rights to use the App and the Service:
      </p>
      <ul>
        <li>you must stop all activities authorised by these terms, including your use of the App and the Service; and</li>
        <li>you must delete or remove the App from all devices in your possession.</li>
      </ul>

      <h4 #S1 id="S1" class="my-3">
        We may transfer this agreement to someone else
      </h4>

      <p>
        We may transfer our rights and obligations under these terms to another organisation. We will always tell you in writing if this happens, and we will ensure that the transfer will not affect your rights under the contract.
      </p>

      <h4 #T1 id="T1" class="my-3">
        You need our consent to transfer your rights to someone else
      </h4>

      <p>
        You may only transfer your rights or your obligations under these terms to another person if we agree in writing.
      </p>

      <h4 #U1 id="U1" class="my-3">
        No rights for third parties
      </h4>

      <p>
        This agreement does not give rise to any rights under the Contracts (Rights of Third Parties) Act 1999 to enforce any term of this agreement.
      </p>

      <h4 #V1 id="V1" class="my-3">
        If a court finds part of this contract illegal, the rest will continue in force
      </h4>

      <p>
        Each of the paragraphs of these terms operates separately. If any court or relevant authority decides that any of them are unlawful, the remaining paragraphs will remain in full force and effect.
      </p>

      <h4 #W1 id="W1" class="my-3">
        Even if we delay in enforcing this contract, we can still enforce it later
      </h4>

      <p>
        If we do not insist immediately that you do anything you are required to do under these terms, or if we delay in taking steps against you in respect of your breaking this agreement, that will not mean that you do not have to do those things and it will not prevent us taking steps against you at a later date.
      </p>

      <h4 #X1 id="X1" class="my-3">
        Which laws apply to this agreement and where you may bring legal proceedings
      </h4>

      <p>
        These terms are governed by English law, and you can bring legal proceedings in respect of the App and the Service in the English courts. If you live in Scotland, you can bring legal proceedings in either the Scottish or the English courts. If you live in Northern Ireland, you can bring legal proceedings in either the Northern Irish or the English courts.
      </p>

    </div>
  </div>

</div>
